import { EmptyObject } from 'type-fest'
import { PlanTypeVariableKey } from '../types/PlanTypeVariableKey'

/**
 * Defines strong types for feature flags, such that whenever the given key is used
 * the variables will be typed appropriately to its value.
 *
 * If a Feature Flag does not have variables, use `EmptyObject`.
 */
export interface FeatureFlags {
  buy_plan_page: Record<PlanTypeVariableKey, string>
  flowcode_limit_upsell_modal: Record<PlanTypeVariableKey, string>
  pricing_plan_group: { group: string }
  enable_geo_smart_rules: EmptyObject
  new_payment_methods: boolean
  disable_automatic_payment_method_types: { defaultPaymentMethods: string }
}

export const HOME_PHASE_3 = 'home_phase_3'
export const HOME_PAGE = 'user_homepage'
export const HUBSPOT_CRM_INTEGRATION = 'hubspot_crm_integration'
export const SALESFORCE_CRM_INTEGRATION = 'salesforce_crm_integration'
export const ENABLE_SHOPPING_CART_DYNAMIC_SHIPPING = 'enable_shopping_cart_dynamic_shipping'
export const GEOLOCATION_INTERSTITIAL = 'geolocation_interstitial'
export const ENABLE_MERGED_STORE_FLOWTAG_BTM_BANNER = 'enable_merged_store_flowtag_btm_banner'
export const GLOBAL_SEARCH_BAR = 'global_search_bar'
export const DISABLE_AUTO_DESIGN_LOGO_RESIZE = 'disable_auto_design_logo_resize'
export const DISABLE_AUTO_LOGO_RESIZE = 'disable_auto_logo_resize'
export const FP_RICH_TEXT_BOX_SECTION = 'rich_text_box_section'
export const CRM_FORMS = 'crm_forms'
export const UPDATE_THE_DESKTOP_LEFT_NAV = 'update_the_desktop_left-nav'
export const BUNDLES = 'bundles'
export const VIEW_LIVE_FORM_RESULTS = 'view_live_form_results'
export const CRM_VIEW_SUBMISSIONS = 'crm_view_submissions_page'
export const SELF_SERVICE_UPGRADE_TO_PROFLEX = 'self_service_upgrade_to_proflex'
export const TRANSFER_FOLDER = 'transfer_folder'
export const TEMPLATES_ENTRY_POINT = 'templates_entry_point'
export const UNIFIED_DISCOVER_TEMPLATES = 'unified_discover_templates'
export const UNIFIED_YOUR_TEMPLATES = 'unified_your_templates'
export const DISPLAY_UNIFIED_TEMPLATES_NEW_LABEL = 'display_unified_templates_new_label'
export const UNIFIED_ASSET_MANAGEMENT = 'unified_asset_management_q2_2023'
export const ATLAS_FEATURE_FLAG = 'atlas'
export const BRAND_KIT = 'enable_brand_kit'
export const ANALYZE_FLOWCODE_IMAGE_ML = 'analyze_flowcode_image_ml'
export const HIDE_UAM_ARCHIVE_PERMANENTLY_DELETE = 'hide_uam_archive_permanently_delete'
export const SHOW_ONBOARDING_FLOW = 'show_onboarding_flow'
export const CODE_DETAILS_TILES = 'code_details_tiles'
export const ONBOARDING_FEATURES = 'onboarding_questions'
export const LOCG_TEST_SIGNUP_AND_CREATE_ENDPOINT = 'locg_test_signup_and_create_endpoint'
export const SHOW_EMAIL_MODAL = 'show_email_modal'
export const AUTOSHARING_ASSETS = 'autosharing_assets_q1_2024'
export const LABEL_PAGE_TEMPLATES_IN_UAM = 'label_page_templates_in_uam'
export const UPDATED_VERSION_OF_THE_TRIAL_INTRO_MODAL = 'updated_version_of_the_trial_intro_modal'
export const ASSET_LOADING_STATE_TIMEOUT_DIALOGS = 'asset_loading_state_timeout_dialogs'
export const DESKTOP_ADD_TRIAL_BANNER_TEXT = 'desktop_add_trial_banner_text'
export const ENABLE_BULK_CODE_CREATION_V2 = 'licgv2_bulk_code_creation_ui'
export const ENABLE_DESTINATION_INPUTS_V2 = 'licgv2_destination_inputs'
export const ENABLE_BUTTON_IN_TOP_NAV_V2 = 'licgv2_top_nav_exit_button'
export const ENABLE_CONFIG_ACCORDION_V2 = 'licgv2_config_accordion'
export const STATIC_CODE_CREATION = 'static_code_creation'
